export default __webpack_public_path__ + "static/new_white_arrow-350ff0a722c46ed3aef2faed210aee87.svg";